import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classNames from "classnames";
import { Controller } from "react-hook-form";
import CalendarIcon from "../../../../../shared/icons/CalendarIcon";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
import "./DateInput.scss";
function DateComp({
  fieldControl,
  isError,
  fieldSettings,
  id,
  text
}) {
  const DatePickerComponent = typeof DatePicker === "function" ? DatePicker : DatePicker.default;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("general-input-wrapper-view", {
      dateContainer: true,
      ["error"]: isError
    })
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    color: "#667085"
  }), /*#__PURE__*/React.createElement(Controller, {
    control: fieldControl,
    name: id,
    render: ({
      field
    }) => /*#__PURE__*/React.createElement(DatePickerComponent, {
      dateFormat: "yyyy/MM/dd",
      popperModifiers: [{
        name: "flip",
        enabled: false
      }],
      showPopperArrow: false,
      onChange: date => field.onChange(date),
      placeholderText: text[fieldSettings?.placeholder?.textId],
      selected: field?.value,
      popperPlacement: "auto",
      calendarClassName: classNames({
        calenderStyle: true
      })
    })
  }), /*#__PURE__*/React.createElement("div", null, isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null)));
}
export default DateComp;
//# sourceMappingURL=DateInput.js.map